module.exports = __webpack_public_path__ + "img/pic_banner_jp.039cae09.jpg";